import { create } from 'zustand';
import { Predicate } from '../../models/predicate.model';

type Store = {
  turmasPredicate: Predicate;
};
export const useTurmasPredicateStore = create<Store>((set) => ({
  turmasPredicate: new Predicate(),
}));
